// extracted by mini-css-extract-plugin
export default {"match-tag":"MatchItem_match-tag__lnMct","match-tag__label":"MatchItem_match-tag__label__AU9Da","match-tag__icon":"MatchItem_match-tag__icon__w5ilg"};